<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 15:07:10
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:51:43
 * @name: 型号添加或编辑
 * @Description: 型号添加或编辑
 * @FilePath: \preSaleNafterSaleBackstage\src\components\modelGoodsManage\dialog\addNedit-model.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog ref="addNeditDialog" :title="title[titleIndex]">
    <template v-slot:form>
      <div class="line">
        <font class="label">所属品牌:</font>
        <font class="text">{{ form.brand_name }}</font>
      </div>
      <div class="line">
        <font class="label">所属系列:</font>
        <el-select
          class="input"
          v-model="form.parent_id"
          placeholder="请选择所属系列"
        >
          <el-option
            v-for="item of modelGoods.options_series"
            :key="item.id"
            :label="item.category_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label"><i class="warn">*</i>型号名称:</font>
        <el-input
          class="input"
          v-model="form.name"
          placeholder="请输入型号名称"
        ></el-input>
      </div>
      <div class="line">
        <font class="label">状态:</font>
        <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button class="submit" type="primary" @click="submit">提交</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog.vue";
export default {
  name: "modelGoodsManage-addNeditModel",
  components: {
    addNeditDialog,
  },
  props: {
    modelGoods: {
      type: Object,
    },
  },
  data() {
    return {
      title: ["添加型号", "编辑型号"], //标题可选数组
      titleIndex: 0, //标题选择序号
      id: "", //型号id
      form: {
        //表单数据
        brand_id: "", // 所属品牌id
        brand_name: "", //所属品牌名称
        parent_id: "", // 所属系列id
        name: "", //型号名称
        status: true, //型号状态
      },
    };
  },
  computed: {
    // 验证型号名是否已填
    name_match() {
      return !this.form.name;
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗,编辑状态赋初始值
     * @param {Object | undefind} form 品牌原数据 | 未传
     */
    open(form) {
      let {
        id: category_id,
        category_name: name,
        status,
      } = form || { id: "", category_name: "", status: 1 }; //传了值赋值,未传值赋默认值
      this.category_id = category_id; //赋值id
      this.form = { name, status }; //赋值表单数据
      this.titleIndex = category_id ? 1 : 0; //判断是否有id,有即编辑,否则为添加
      this.getBrand();
      this.getOptionsSeries();
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取所属品牌
     */
    getBrand() {
      this.form.brand_id = this.modelGoods.table_series_data.id;
      this.form.brand_name = this.modelGoods.table_series_data.category_name;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取品牌选择框数组
     */
    getOptionsSeries() {
      this.modelGoods
        .getOptionsSeriesByBrand({
          parent_id: this.form.brand_id,
          limit: 10000,
        })
        .then((res) => {
          //赋默认值,判断默认值是否在可选数组内存在
          if (
            this.modelGoods.options_series.findIndex(
              (x) => x.id === this.modelGoods.table_model_data.id
            ) > -1
          ) {
            this.$set(
              this.form,
              "parent_id",
              this.modelGoods.table_model_data.id
            );
          }
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交,判断是否有id,有即编辑,否则为添加
     */
    @debounceation(300)
    submit() {
      this.category_id &&
        this.$emit("edit", { category_id: this.category_id, ...this.form });
      this.category_id || this.$emit("add", this.form);
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
  .text {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>